(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
       var headerHeight = $('.section-header').outerHeight();
       var scrollTop = $(window).scrollTop();
        
        if(scrollTop > 100){
          $('.section-header').addClass('invisible');         
        }    
      
      window.addEventListener('resize', () => {
        this.updateHeaderPosition();     
        this.setHeaderHeight();
      });
      this.createObserver();     
      this.updateHeaderPosition();     
    }

    updateHeaderPosition() {     
      if (window.innerWidth <= 1023) {
          let announcementBarHeight = this.announcementBar ? $(this.announcementBar).outerHeight() : 0;
          if (!this.header.classList.contains('shopify-section-header-hidden')) {
            $('.section-header').css('top', `${announcementBarHeight}px`);
        }    
      }
    }
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);     
      if (this.announcementBar) {
        document.documentElement.style.setProperty('--announcement-height', `${this.announcementBar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.updateHeaderPosition.bind(this));
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      if (scrollTop > this.currentScrollTop) {
        this.header.classList.add('scrolled-past-header');
        // if (this.preventHide) return;
        if (!this.announcementBar) {
          if (this.preventHide) return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;    
      $('.section-header').removeClass('invisible');    
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();          
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');      
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      $('.section-header').removeClass('invisible');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      // this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // this.searchModal.close(false);
    }
  }

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('sticky-header', StickyHeader);
  const inlineMenu = document.querySelector(".header__inline-menu");
  const detailsItems = inlineMenu.querySelectorAll("details");
  detailsItems.forEach(item => {
      const ulElement = item.querySelector("ul");
      const stickyHeader = item.closest("sticky-header");
      item.addEventListener("mouseover", () => {       
        item.setAttribute("open", true);     
        ulElement.addEventListener("mouseleave", () => {         
          item.removeAttribute("open");          
        });
        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");         
      });  
    });
  });
 const stickyHeader = inlineMenu.closest("sticky-header");
  inlineMenu.addEventListener("mouseover", () => {
    stickyHeader.classList.add("hover-background-item");    
  });
  inlineMenu.addEventListener("mouseleave", () => {
    stickyHeader.classList.remove("hover-background-item");
  });
   const menuItems = document.querySelectorAll('.mega-menu__list-title li'); 
   let currentVisibleSubMenu = null;

    menuItems.forEach(item => {
    item.addEventListener('mouseover', function() {
      const megaMenu = item.closest('.mega-menu__wrapper');
      const subMenus = megaMenu.querySelectorAll('.mega-menu__list-sub');    
      const curMenuItems = megaMenu.querySelectorAll('.mega-menu__list-title li');
      const promoWrapper = megaMenu.parentNode.querySelector('.promo_image-wrapper');
      const promoImages = promoWrapper.querySelectorAll('.promo_image');   
      curMenuItems.forEach(menuItem => {
          menuItem.classList.remove('active_Link');
      });
       subMenus.forEach(submenu => {
          submenu.classList.add('hidden');
      });    
      promoImages.forEach(image => {
          image.classList.add('hidden');
      });
      const submenuId = item.getAttribute('data-submenu');      
      const submenu = megaMenu.querySelector(`#${submenuId}`);      

      const promoImage = promoWrapper.querySelector(`.promo_image[data-img="${submenuId}"]`);
      if (submenu) {
        submenu.classList.remove('hidden');
      }
      if (promoImage) {
          promoImage.classList.remove('hidden');
      }
      item.classList.add('active_Link');
    });
  }); 
});

  } catch(e) { console.error(e); }
})();
})();
